var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysCommission = function SvgSysCommission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.353 11.6h-3.137m3.137 0c1.495-.09 1.754-2.57.185-3.401C14.2 8.02 13.808 8 13.425 8H9.47a2 2 0 0 0-1.382.555L5.529 11m8.824.6L17.5 11l2.346-.631a1.462 1.462 0 0 1 1.78.989v0a1.462 1.462 0 0 1-.815 1.762l-1.965.859c-.641.28-1.304.51-1.981.689l-4.06 1.069A8.003 8.003 0 0 1 10.77 16h-5.24m0-5H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2.53m0-5v5"
  })));
};
export default SvgSysCommission;